export default __webpack_public_path__ + "static/media/proj1_2.95809aea.jpg";